"use strict";
// _partialFile.js

{
  jQuery(function ($) {
    $(".p-tab__btn").on("click", function () {
      // tabの切り替え
      $(".p-tab__btn").attr("aria-selected", "false");
      $(this).attr("aria-selected", "true");

      // tab panelの切り替え
      $(".p-tab__contentWrap").removeClass("js-show");
      $("#" + $(this).attr("aria-controls")).addClass("js-show");

      return false;
    });
  });
}
